// extracted by css-extract-rspack-plugin
export default {"container":"_868208fc","content":"_319cb8b2","button":"_ca2b6aed","mobileBreak":"_8563b124","heading":"_ca540273"};